"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Checkbox = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _includes = require("@paprika/stylers/lib/includes");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var types = _interopRequireWildcard(require("./types"));

var _styles;

var getLabelLeftPadding = function getLabelLeftPadding(checkboxSize, hasLabel) {
  return hasLabel ? "".concat((0, _helpers.toInt)(checkboxSize) + (0, _helpers.toInt)(_tokens["default"].space), "px") : checkboxSize;
};

var smallCheckboxSize = _tokens["default"].checkbox.sizeSm;
var mediumCheckboxSize = _tokens["default"].checkbox.sizeMd;
var largeCheckboxSize = _tokens["default"].checkbox.sizeLg;
var styles = (_styles = {}, (0, _defineProperty2["default"])(_styles, types.SMALL, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-1), "px")
  },
  checkBoxStyles: {
    height: smallCheckboxSize,
    width: smallCheckboxSize
  },
  checkBoxIconStyles: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-3), "px"),
    height: smallCheckboxSize,
    left: "".concat((0, _helpers.toInt)(smallCheckboxSize) / 2, "px")
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: smallCheckboxSize,
      padding: "0 0 0 ".concat(getLabelLeftPadding(smallCheckboxSize, hasLabel))
    };
  }
}), (0, _defineProperty2["default"])(_styles, types.MEDIUM, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(), "px")
  },
  checkBoxStyles: {
    height: mediumCheckboxSize,
    width: mediumCheckboxSize
  },
  checkBoxIconStyles: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(-1), "px"),
    height: mediumCheckboxSize,
    left: "".concat((0, _helpers.toInt)(mediumCheckboxSize) / 2, "px")
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: mediumCheckboxSize,
      padding: "1px 0 0 ".concat(getLabelLeftPadding(mediumCheckboxSize, hasLabel))
    };
  }
}), (0, _defineProperty2["default"])(_styles, types.LARGE, {
  baseFontSize: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(), "px")
  },
  checkBoxStyles: {
    height: largeCheckboxSize,
    width: largeCheckboxSize
  },
  checkBoxIconStyles: {
    fontSize: "".concat((0, _helpers.fontSizeValue)(), "px"),
    height: largeCheckboxSize,
    left: "".concat((0, _helpers.toInt)(largeCheckboxSize) / 2, "px")
  },
  labelStyles: function labelStyles(hasLabel) {
    return {
      minHeight: largeCheckboxSize,
      padding: "3px 0 0 ".concat(getLabelLeftPadding(largeCheckboxSize, hasLabel))
    };
  }
}), _styles);

var Checkbox = _styledComponents["default"].div.withConfig({
  displayName: "Checkboxstyles__Checkbox",
  componentId: "sc-1lgsomq-0"
})(function (_ref) {
  var size = _ref.size,
      hasLabel = _ref.hasLabel;
  return (0, _styledComponents.css)(["", ";", ";line-height:", ";position:relative;& + [data-pka-anchor=\"checkbox\"]{margin-top:", ";}input[type=\"checkbox\"]{", ";&:focus + label::before{box-shadow:", ";border-color:", ";}& + label{cursor:pointer;display:inline-block;margin:0;", ";position:relative;}& + label::before,& + label > .checkbox-icon{position:absolute;top:0;}& + label::before{background:", ";border:2px solid ", ";border-radius:", ";content:\"\";left:0;", ";", ";}& + label:hover::before{border:2px solid ", ";}& + label > .checkbox-icon{color:", ";", ";opacity:0;pointer-events:none;transform:translateX(-50%);transition:opacity 0.15s ease-out;", ";}&:checked,&:indeterminate{& + label::before{background:", ";border:none;}& + label:hover::before{background:", ";}}&:checked + label > [data-pka-anchor=\"checkbox.icon.check\"]{opacity:1;}&:indeterminate + label > [data-pka-anchor=\"checkbox.icon.check\"]{opacity:0;}&:indeterminate + label > [data-pka-anchor=\"checkbox.icon.indeterminate\"]{opacity:1;}&:disabled{& + label,& ~ .checkbox-icon{cursor:not-allowed;opacity:0.5;transition:none;}&:checked,&:indeterminate{& + label::before{background-color:", ";}& + label:hover::before{border:none;}}& + label:hover::before{border:2px solid ", ";}}}"], _includes.boxSizingStyles, styles[size].baseFontSize, hasLabel ? (0, _helpers.lineHeightValue)(-1) : "0", _tokens["default"].space, _includes.visuallyHidden, _tokens["default"].highlight.active.noBorder.boxShadow, _tokens["default"].highlight.active.noBorder.borderColor, styles[size].labelStyles(hasLabel), _tokens["default"].color.white, _tokens["default"].border.color, _tokens["default"].border.radius, (0, _helpers.z)(1), styles[size].checkBoxStyles, _tokens["default"].color.black, _tokens["default"].color.white, styles[size].checkBoxIconStyles, (0, _helpers.z)(2), _tokens["default"].color.black, _tokens["default"].color.blackLighten30, _tokens["default"].color.blackLighten40, _tokens["default"].border.color);
});

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.styles.js.map